// eslint-disable-next-line import/order
import { Breadcrumb, breadcrumbMountedEventChannel, internalGasV3OperationalEventChannel, internalGasV3ScreenEventChannel, internalGasV3TrackEventChannel, internalGasV3UIEventChannel, internalSentryExceptionChannel } from '../channels';
export { Breadcrumb };
import { createAtlaskitToEventChannelRepackager } from '../events/atlaskit';
import { withBreadcrumb as baseWithBreadcrumb } from '../events/breadcrumbs';
var useGasV3UIEventDispatch = internalGasV3UIEventChannel.useBreadcrumbedEventDispatch;
export { useGasV3UIEventDispatch };
var useGasV3ScreenEventDispatch = internalGasV3ScreenEventChannel.useEventDispatch;
export { useGasV3ScreenEventDispatch };
var useGasV3TrackEventDispatch = internalGasV3TrackEventChannel.useBreadcrumbedEventDispatch;
export { useGasV3TrackEventDispatch };
var useGasV3OperationalEventDispatch = internalGasV3OperationalEventChannel.useBreadcrumbedEventDispatch;
export { useGasV3OperationalEventDispatch };
var useSentryExceptionDispatch = internalSentryExceptionChannel.useBreadcrumbedEventDispatch;
export { useSentryExceptionDispatch };
export var RepackageAtlaskitEvent = createAtlaskitToEventChannelRepackager(useGasV3UIEventDispatch);

/**
 * TODO: Old APIs need this to be exposed. Remove whatever's using this and then remove this.
 */
var BreadcrumbMountedListener = breadcrumbMountedEventChannel.Listener;
export { BreadcrumbMountedListener };
export var withBreadcrumb = function withBreadcrumb(Component, name, attributes) {
  return baseWithBreadcrumb(Component, Breadcrumb, name, attributes);
};